// extracted by mini-css-extract-plugin
export default {"pageLayout":"m-z","mainContent":"n-z","columnLayout":"o-z","columnLayoutFill":"p-z","columnLayoutLast":"q-z"};